module.exports = __webpack_public_path__ + "img/man.699fe31e.svg";